export { default as DefaultPage } from './DefaultPage';
export { default as PlanLngPage } from './Plan_lngPage';


// WEBPACK FOOTER //
// ./src/features/plan/index.js